var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "hero"
  }, [_c('b-container', [_c('b-row', [_c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "6",
      "offset-md": "3"
    }
  }, [_c('h1', {
    staticClass: "display-1"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "check"
    }
  })], 1), _c('h1', [_vm._v("Membership Subscribed")]), _c('p', [_vm._v("\n            Thank you for subscribing to our membership. You will receive an email shortly with all details.\n          ")]), _c('div', {
    staticClass: "mt-4"
  }, [_c('a', {
    staticClass: "btn btn-dark ml-3",
    attrs: {
      "href": "https://routeline.web.app/login"
    }
  }, [_vm._v("Signin"), _c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-right"
    }
  })], 1)])])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }